import { IAddress } from 'checkout/types/Address';
import { FieldType } from './FieldType';

export const ADDRESS_DEFAULT_INITIAL_VALUES: IAddress = {
  name: '',
  address1: '',
  address2: '',
  city: '',
  postalCode: '',
  countryCode: '',
  phone: '',
  state: '',
  email: '',
};

export const CHINA_COUNTRY_CODE = 'CN';

export const ADDRESS_FIELD_TYPE_MAP = {
  [FieldType.FullName]: {
    autoComplete: 'name',
    type: 'text',
  },
  [FieldType.StreetAddress]: {
    autoComplete: 'street-address',
    type: 'text',
  },

  [FieldType.UnitNumber]: {
    type: 'text',
  },
  [FieldType.City]: {
    autoComplete: 'address-level2',
    type: 'text',
  },
  [FieldType.PostalCode]: {
    autoComplete: 'postal-code',
    type: 'text',
  },
  [FieldType.Phone]: {
    autoComplete: 'tel',
    type: 'tel',
  },
  [FieldType.CustomerIdNumber]: {
    type: 'text',
  },
};
